export const STANDARD_GA4_PARAMS = [
    'page_location', 'batch_ordering_id', 'page_title', 'batch_page_id',
    'ga_session_id', 'ga_session_number', 'session_engaged',
    'engaged_session_event', 'page_referrer', 'engagement_time_msec',
    'source', 'campaign', 'medium', 'content', 'term', 'ignore_referrer',
    'value', 'transaction_id'
];

export const STANDARD_GA4_EVENTS = [
    // Automatically collected
    'session_start', 'first_visit', 'user_engagement', 'page_view', 'scroll',
    'click', 'view_search_results', 'video_start', 'video_progress',
    'video_complete', 'file_download', 'form_start', 'form_submit',
    // Recommended - All properties
    'ad_impression', 'earn_virtual_currency', 'generate_lead', 'join_group',
    'login', 'purchase', 'refund', 'search', 'select_content', 'share',
    'sign_up', 'spend_virtual_currency', 'tutorial_begin', 'tutorial_complete',
    // Recommended - Online Sales
    'add_payment_info', 'add_shipping_info', 'add_to_cart', 'add_to_wishlist',
    'begin_checkout', 'remove_from_cart', 'select_item', 'select_promotion',
    'view_cart', 'view_item', 'view_item_list', 'view_promotion',
    // Recommended - Lead Gen
    'qualify_lead', 'disqualify_lead', 'working_lead', 'close_convert_lead',
    'close_unconvert_lead',
    // Recommended - Games
    'level_end', 'level_start', 'level_up', 'post_score', 'unlock_achievement'
];
